import {
  finalExamGradeList,
  finalExamGradeAdd,
  finalExamGradeEdit,
  finalExamGradeDelete,
  finalExamGradeSubmit,
  finalExamGradeFileSave,
} from '@/api/final_exam'

export default {
  async finalExamGradeList({ }, data) {
    return finalExamGradeList(data)
  },
  async finalExamGradeAdd({ }, data) {
    return finalExamGradeAdd(data)
  },
  async finalExamGradeEdit({ }, data) {
    return finalExamGradeEdit(data)
  },
  async finalExamGradeDelete({ }, data) {
    return finalExamGradeDelete(data)
  },
  async finalExamGradeSubmit({ }, data) {
    return finalExamGradeSubmit(data)
  },
  async finalExamGradeFileSave({ }, data) {
    return finalExamGradeFileSave(data)
  },
}
